import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LivingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"living"}/>
}
